import styled from "styled-components";

const DeclerationWrapper = styled.div`
.Dec-det {
  margin: 20px 0;padding: 22px;background: #F2F3F5;border-bottom: 2px solid #F2F3F5;border-radius: 8px;
}
.Heading-dec {

font-weight: 800;font-size: 1.25rem;color: #4C565C;
}
.Subheading{font-weight: 400;font-size: 1rem;color: #4C565C;margin:0;}
.visa-hr {
  margin-bottom: 0 !important;
}
.Dec-Input {
  .p-inputtext {
    border: none;
    width: 100%;
    font-weight: 700;
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 4px;
    font-size: 1rem;
    color: #4c565c;
    padding: 1.3rem 0.75rem 0.4rem 0.75rem;
  }
  .p-float-label input:focus ~ label,
  .p-float-label input.p-filled ~ label {
    // top: 0.75rem;
    // font-size: 0.7rem;
    top: 1rem;
    font-size: 0.7rem;
  }
}
.Dec-Input{
	label{
		right:12px;
	}
}
.p-float-label input.p-filled ~ label {
  top: 1rem;
  font-size: 0.7rem;
}

.p-radiobutton .p-radiobutton-box.p-highlight{
  border-color: ${props => `${props.businessColor} !important`};
  background: ${props => `${props.businessColor} !important`};
}
.p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
  border-color: ${props => props.businessColor};
}

@media screen and (max-width: 767px) {
  .d-flex {
    display: block !important;
  }
  .field-radiobutton{
    display: flex;
    margin-bottom: 10px;
  }

}
`;

export default DeclerationWrapper;
